import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Skeleton from './Skeleton'; // Certifique-se de importar o componente de Skeleton

const Shortcut = ({ to, icon, label, disabled, loading }) => {
  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center p-6 bg-white rounded-xl shadow-lg">
        <Skeleton lines={1} height="h-12" width="w-12" radius="rounded-full" />
        <Skeleton lines={1} height="h-6" width="w-3/4" />
      </div>
    );
  }

  return (
    <Link
      to={to}
      className={`flex flex-col items-center justify-center p-6 bg-white rounded-xl shadow-lg transition transform hover:scale-105 hover:shadow-2xl focus:outline-none focus:ring-4 focus:ring-primary focus:ring-opacity-50 
      ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      style={disabled ? { pointerEvents: 'none' } : {}}
      aria-label={label}
      aria-disabled={disabled ? 'true' : 'false'}
      tabIndex={disabled ? -1 : 0}
      data-testid="shortcut-link"
    >
      <div
        className={`text-3xl mb-3 transition-colors ${
          disabled ? 'text-gray-400' : 'text-primary'
        }`}
        data-testid="shortcut-icon"
      >
        {icon}
      </div>
      <p
        className={`text-lg font-semibold transition-colors ${
          disabled ? 'text-gray-400' : 'text-dark-gray'
        }`}
        data-testid="shortcut-label"
      >
        {label}
      </p>
    </Link>
  );
};

Shortcut.propTypes = {
  to: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool, // Adiciona a prop para o estado de carregamento
};

Shortcut.defaultProps = {
  disabled: false,
  loading: false, // O estado padrão para carregamento é falso
};

export default Shortcut;
